export const fromClientToFrame = {
  init: 'init',
  getTheme: 'getTheme',
  setTheme: 'setTheme',
  getLanguage: 'getLanguage',
  setLanguage: 'setLanguage',
  createCartItem: 'createCartItem',
};

export const fromFrameToClient = {
  created: 'created',
  syncSize: 'syncSize',
  inited: 'inited',
  sendTheme: 'sendTheme',
  sendLanguage: 'sendLanguage',
  sendPaymentData: 'sendPaymentData',
  sendOrderFromBalanceCreated: 'sendOrderFromBalanceCreated',
  sendOrderFromLinkedCardCreated: 'sendOrderFromLinkedCardCreated',
  orderCreated: 'orderCreated',
};
